module.exports = __webpack_public_path__ + "img/hero@2x.323b646c.webp";